import React from "react";

function InvalidRoute() {
  return <h4 className="text-xl text-center py-4">Page Not Found!</h4>;
}

export default InvalidRoute;
